import { SafePromise } from '@benzinga/safe-await';
import { RestfulClient, Session } from '@benzinga/session';
import {
  GovernmentTrade,
  GovernmentMember,
  MonthlyOverview,
  Overview,
  Security,
  SecuritiesOverview,
  TradingPerformance,
  MembersOverview,
  TradesQuery,
} from './entities';
import { GovTradesEnvironment } from './environment';

export class GovTradesRestful extends RestfulClient {
  constructor(session: Session) {
    super(session.getEnvironment(GovTradesEnvironment).url, session, {
      // authorizationSession: true,
      // 'x-device-key': true,
    });
  }

  getTrades = (query: TradesQuery = {}): SafePromise<{ data: GovernmentTrade[] }> => {
    const { chamber, dateFrom, dateTo, page = 0, pageSize = 20, sort, ticker } = query;
    const url = this.URL('/api/v1/gov/usa/congress/trades', {
      page,
      pagesize: pageSize,
      token: this.session.getEnvironment(GovTradesEnvironment).token,
      ...(ticker ? { search_keys: ticker, search_keys_type: 'ticker' } : {}),
      ...(chamber ? { chamber } : {}),
      ...(dateFrom ? { date_from: dateFrom } : {}),
      ...(dateTo ? { date_to: dateTo } : {}),
      ...(sort ? { sort } : {}),
    });
    return this.get(url, { allowsAnonymousAuth: true, credentials: 'same-origin' });
  };

  getReports = (): SafePromise<{ data: GovernmentTrade[] }> => {
    const url = this.URL('/api/v1/gov/usa/congress/trades/reports', {
      token: this.session.getEnvironment(GovTradesEnvironment).token,
    });
    return this.get(url, { allowsAnonymousAuth: true, credentials: 'same-origin' });
  };

  getOverview = (): SafePromise<Overview[]> => {
    const url = this.URL('/api/v1/gov/usa/congress/analytics/overview/investments', {
      token: this.session.getEnvironment(GovTradesEnvironment).token,
    });
    return this.get(url, { allowsAnonymousAuth: true, credentials: 'same-origin' });
  };

  getOverviewMonthly = (): SafePromise<MonthlyOverview[]> => {
    const url = this.URL('/api/v1/gov/usa/congress/analytics/overview/monthly_trades', {
      token: this.session.getEnvironment(GovTradesEnvironment).token,
    });
    return this.get(url, { allowsAnonymousAuth: true, credentials: 'same-origin' });
  };

  getSecurities = (): SafePromise<SecuritiesOverview[]> => {
    const url = this.URL('/api/v1/gov/usa/congress/analytics/securities', {
      token: this.session.getEnvironment(GovTradesEnvironment).token,
    });
    return this.get(url, { allowsAnonymousAuth: true, credentials: 'same-origin' });
  };

  getSecurity = (symbol: string): SafePromise<Security[]> => {
    const url = this.URL(`/api/v1/gov/usa/congress/analytics/securities/${symbol}`, {
      token: this.session.getEnvironment(GovTradesEnvironment).token,
    });
    return this.get(url, { allowsAnonymousAuth: true, credentials: 'same-origin' });
  };

  getMembers = (): SafePromise<MembersOverview[]> => {
    const url = this.URL('/api/v1/gov/usa/congress/analytics/members', {
      token: this.session.getEnvironment(GovTradesEnvironment).token,
    });
    return this.get(url, { allowsAnonymousAuth: true, credentials: 'same-origin' });
  };

  getMember = (id: string): SafePromise<GovernmentMember[]> => {
    const url = this.URL(`/api/v1/gov/usa/congress/analytics/members/${id}`, {
      token: this.session.getEnvironment(GovTradesEnvironment).token,
    });
    return this.get(url, { allowsAnonymousAuth: true, credentials: 'same-origin' });
  };

  getCongressTradingPerformance = (): SafePromise<TradingPerformance[]> => {
    const url = this.URL('/api/v1/gov/usa/congress/analytics/trading_performance', {
      token: this.session.getEnvironment(GovTradesEnvironment).token,
    });
    return this.get(url, { allowsAnonymousAuth: true, credentials: 'same-origin' });
  };

  getTradingPerformanceByMember = (id: string): SafePromise<TradingPerformance[]> => {
    const url = this.URL(`/api/v1/gov/usa/congress/analytics/trading_performance/${id}`, {
      token: this.session.getEnvironment(GovTradesEnvironment).token,
    });
    return this.get(url, { allowsAnonymousAuth: true, credentials: 'same-origin' });
  };
}
